module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-d208ae1ba7fd36526f63e726d0c787dc.svg";